import { LadiesMain } from "../global/ladies-main"
import { makeSureVueIsLoaded } from "./vue.js"

window.redirectWithCorrectReferrer = (args) => {
    const isLoggedIn = userData.isLoggedIn
    if (!isLoggedIn && args && args.reLogin) {
        // no reLogin if not loggedIn already
        return
    }
    window.location.href = `/login?ref=${encodeURIComponent(`frankfurt-main/sex-anzeigen${window.location.hash}`)}`
}

window.mountBannerFree = () => {
    const baseURL = SiteInfo.loginUrl
    const IDEJAL_PAYMENT_URL = SiteInfo.paymentUrl
    const BACKEND_SHOP_URL = SiteInfo.paymentBackendShopUrl
    const headers = {
        Authorization: `Bearer ${SiteInfo.accessToken}`,
        Accept: "application/json",
    }
    const store = {}

    Vue.use(window["vue-components"].default, { headers, baseURL, IDEJAL_PAYMENT_URL, BACKEND_SHOP_URL })
    Vue.prototype.extendStore(store)
    new Vue({
        data: {
            store,
        },
        mounted() {
            this.$config.DASHBOARD_URL = SiteInfo.loginDashboardUrl
            this.$config.IDEJAL_ORDER_BACKEND_URL = SiteInfo.paymentOrderBackendUrl
            this.$config.BACKEND_SHOP_URL = SiteInfo.paymentBackendShopUrl
        },
    }).$mount("#banner-free-app")

    window.sharedBannerFreeMounted = true
}

$("#banner-free-modal").on("show.bs.modal", async () => {
    await makeSureVueIsLoaded()
    if (typeof window.sharedComponentsLoaded === "undefined") {
        // modal is opened for the first time
        // load css
        const fileRef = document.createElement("link")
        fileRef.setAttribute("rel", "stylesheet")
        fileRef.setAttribute("type", "text/css")
        fileRef.setAttribute(
            "href",
            `https://static.ladies-cdn.de/ladies/shared/${SiteInfo.vueComponentVersion}/lib/vue-components.css`,
        )
        document.head.appendChild(fileRef)
        // load js
        const script = document.createElement("script")
        script.onload = mountBannerFree
        script.src = `https://static.ladies-cdn.de/ladies/shared/${SiteInfo.vueComponentVersion}/lib/vue-components.umd.min.js`
        document.head.appendChild(script)
        window.sharedComponentsLoaded = true
    } else if (typeof window.sharedBannerFreeMounted === "undefined") {
        mountBannerFree()
    }

    LadiesMain.addHashtagToUrl("banner-free-modal")
})

$("#banner-free-modal").on("hide.bs.modal", () => {
    LadiesMain.removeHashtagFromUrl("banner-free-modal")
})

$(document).ready(() => {
    if (LadiesMain.checkHashtagInUrl("banner-free-modal")) {
        if (userData.hasAdFree) {
            LadiesMain.removeHashtagFromUrl("banner-free-modal")
        } else {
            $("#banner-free-modal").modal("show")
        }
    }
})
